import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (id: string, data: any) => await httpRequest.post(`/api/repayment/${id}/compromise`, data);
export const list = async (data: any) => await httpRequest.get(`/api/repayment/compromise`, data);
